import { useImperativeHandle } from '@nebula.js/stardust';
import { COLLAPSED_HEIGHT, ITEM_SPACING } from '../components/ListboxGrid/grid-constants';
import type { IContainerElement, IFilterPaneLayout } from './types';

const getCollapsedHeight = (listboxCount: number) => {
  const height = (COLLAPSED_HEIGHT + ITEM_SPACING) * listboxCount - ITEM_SPACING;
  return Math.max(height, 0);
};

const useGetPreferredSize = (containerElement: IContainerElement, fpLayout: IFilterPaneLayout | undefined) => {
  useImperativeHandle(
    () => ({
      // Returns the container size in which the filter-pane is rendered in sense-client. Used when in mobile portrait mode.
      getPreferredSize() {
        const listboxCount = fpLayout?.qChildList?.qItems.length || 0;
        const height = getCollapsedHeight(listboxCount);
        return { w: containerElement.clientWidth, h: height };
      },
    }),
    [containerElement, fpLayout],
  );
};

export default useGetPreferredSize;
